<ng-container>
  <fcom-tabs
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
  >
    <fcom-tab [title]="'SERVICE_FORMS.serviceForms.titles.fromFlights' | finLocalization">
      <ng-container *ngIf="(loginStatus$ | async) === LoginStatus.LOGGED_IN">
        <div
          data-testid="logged-in-flights-intro"
          [innerHTML]="'SERVICE_FORMS.serviceForms.missingPoints.loggedInFlightsIntro' | finLocalization"
        ></div>
        <ng-container *ngTemplateOutlet="modalLink"></ng-container>
        <fin-logged-in-missing-points-form></fin-logged-in-missing-points-form>
      </ng-container>
      <ng-container *ngIf="(loginStatus$ | async) === LoginStatus.NOT_LOGGED_IN">
        <div
          data-testid="not-logged-in-flights-intro"
          [innerHTML]="'SERVICE_FORMS.serviceForms.missingPoints.notLoggedInFlightsIntro' | finLocalization"
        ></div>
        <ng-container *ngTemplateOutlet="modalLink"></ng-container>
        <ng-container *ngIf="!requireLoginToClaimPoints; else login">
          <fin-logged-out-missing-points-form></fin-logged-out-missing-points-form>
        </ng-container>
      </ng-container>
    </fcom-tab>
    <fcom-tab [title]="'SERVICE_FORMS.serviceForms.titles.fromPartners' | finLocalization">
      <div
        data-testid="partner-intro"
        [innerHTML]="'SERVICE_FORMS.serviceForms.missingPoints.partnerIntro' | finLocalization"
      ></div>
      <fin-claim-missing-partner-points-form></fin-claim-missing-partner-points-form>
    </fcom-tab>
  </fcom-tabs>

  <fcom-modal
    [title]="'SERVICE_FORMS.serviceForms.missingPoints.helpTitle' | finLocalization"
    [buttons]="ModalButtons.CLOSE"
    [(open)]="helpModalOpen"
    (close)="blurHelpModal()"
  >
    <div class="pr-medium">
      <cms-unstyled-fragment
        *ngIf="'fragments.missingPointsHelpModal.url' | finLocalization"
        class="block font-body-1 unstyled-fragment-line-height pr-medium-b help-modal"
        [contentUrl$]="'fragments.missingPointsHelpModal.url' | finLocalization | finToObservable"
      >
      </cms-unstyled-fragment>
    </div>
  </fcom-modal>

  <ng-template #modalLink>
    <div class="mr-small-y">
      <button
        #openHelpModalButton
        (click)="openHelpModal($event)"
        class="nordic-blue-900-text font-body-1 ms-medium-b medium-type"
      >
        <span class="underline">{{ 'SERVICE_FORMS.serviceForms.missingPoints.helpLink' | finLocalization }}</span>
      </button>
    </div>
  </ng-template>
</ng-container>

<ng-template #login>
  <fin-login-card
    [title]="'SERVICE_FORMS.serviceForms.missingPoints.loginPromotion.loginHeading'"
    [benefitText]="'SERVICE_FORMS.serviceForms.missingPoints.loginPromotion.claimMissingPointsText'"
    [footnoteText]="'SERVICE_FORMS.serviceForms.missingPoints.loginPromotion.footerText'"
    [showIcon]="true"
    [showForgotPassword]="true"
    [scrollOnCta]="true"
    [benefitMode]="'text'"
  >
  </fin-login-card>
</ng-template>
